module.exports = __webpack_public_path__ + "assets/62.jpg?fc19e1e3d5722e867f99e0dea95e2bf5";